import useSWR from 'swr';
import { fetcher } from '../../services/fetcher';

const API_LIST = '/catalog-items';
const API_DETAIL = (id: number) => `/catalog-items/${id}`;

export interface CatalogItem {
  id: number;
  type: string;
  name: string;
  description?: string | null;
  defaultPrice?: number | null;
  manufacturerId?: number | null;
  categoryId?: number | null;
  isActive: boolean;
  sortOrder?: number | null;
  primaryFileAttachmentId?: number | null;
  createdAt?: string;
  updatedAt?: string | null;
  manufacturer?: { id: number; name: string } | null;
  category?: { id: number; name: string } | null;
  FileAttachment?: Array<{
    id: number;
    fileName: string | null;
    filePath: string | null;
    fileType: string | null;
    fileSize: number | null;
    uploadedAt: string;
  }>;
}

export interface CatalogItemsListResponse {
  records: CatalogItem[];
}

export const useCatalogItems = (type?: string, isActive?: boolean) => {
  const params = new URLSearchParams();
  if (type) params.set('type', type);
  if (isActive !== undefined) params.set('isActive', String(isActive));
  const query = params.toString() ? `?${params.toString()}` : '';

  const { data, error, isLoading, mutate } = useSWR<CatalogItemsListResponse>(`${API_LIST}${query}`, fetcher, {
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
  });

  const records = data?.records ?? [];
  return {
    data: records,
    records,
    isLoading,
    isError: !!error,
    mutate,
  };
};

export const useCatalogItem = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<CatalogItem>(id ? API_DETAIL(id) : null, fetcher, {
    revalidateOnFocus: true,
  });
  return {
    data,
    catalogItem: data,
    isLoading,
    isError: !!error,
    mutate,
  };
};
